import { Fetch } from "../../../shared/Fetch";
import { ITrainer } from "../trainingMasters/trainnerSelectionModule/Table";
import TrainerRatingCard from "./TrainerRatingCard";
import { useEffect, useRef, useState } from "react";

interface IProps {
    reload: boolean,
    toast: any,
}

export interface ICompletedTrainigs {
    schedule_ID?: number,
    form_ID?: number,
    trainerName?: string,
    topic_ID?: number,
    topic?: string,
    topic_Description?: string,
    category?: string,
    category_Description?: string,
    timeFrom?: Date,
    timeTo?: Date,
    fromBranch?: string,
    toBranch?: string,
    dateFrom?: Date,
    // dateTo?: Date,
    trainer_Login_ID?: number,
    trainer_User_Employee_ID?: string,
    rating_ID?: number,
    rating?: number,
    feedback?: string,
    answers?: any
}

export const Table = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: ICompletedTrainigs[], loading: boolean });
    const [reload, setReload] = useState<boolean>(false);

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("CarnivalTraining/getCompletedTrainings", "GET", null, null, props.toast);
        if (response) {
            const data: ICompletedTrainigs[] = await response.json();
            setTableData({ tableData: data, loading: false });
        } else setTableData({ tableData: tableData.tableData, loading: false });
    }

    const reloadTable = () => {
        setReload(!reload);
    }

    useEffect(() => {
        loadTableData();
    }, [reload]);

    return (
        <>
            <div>
                <h1 style={{ textAlign: "center" }}>Rate Your Trainer</h1>
                <div className="flex gap-2 flex-wrap mb-3">
                    {(tableData.tableData || []).map((ele: ICompletedTrainigs) => <TrainerRatingCard singleData={ele} reloadTable={() => reloadTable()} toast={props.toast} />)}
                </div>
            </div>
        </>
    );
}